import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
	const videosCarousel = document.getElementById("video-carousel");

	if (videosCarousel) {
		const videoCarousel = new Splide(videosCarousel, {
			type: "slide",
			perPage: 1,
			perMove: 1,
			//autoplay: true,
			rewind: true,
			gap: "2.4rem",
			pauseOnHover: true,
			arrows: false,
			pagination: false,
			mediaQuery: "min",
			breakpoints: {
				768: {
					perPage: 2,
				},
				996: {
					perPage: 3,
				},
				1920: {
					perPage: 4,
				},
			},
		}).mount();

		//
		// If custom arrows need to be added
		//
		// Custom arrows functionality
		// Find the parent container of the carousel to locate the arrows
		const carouselContainer = videosCarousel.closest(
			".video-carousel-container"
		);
		if (carouselContainer) {
			const prevButton = carouselContainer.querySelector(".custom-prev");
			const nextButton = carouselContainer.querySelector(".custom-next");
			// add event listener if buttons exists
			if (prevButton) {
				prevButton.addEventListener("click", () => {
					videoCarousel.go("-1");
				});
			}
			if (nextButton) {
				nextButton.addEventListener("click", () => {
					videoCarousel.go("+1");
				});
			}

						// Function to toggle arrow visibility
						const toggleArrows = () => {
							const totalSlides = videoCarousel.length;
							const perPage = videoCarousel.options.perPage;
			
							if (prevButton && nextButton) {
								if (totalSlides <= perPage) {
									prevButton.style.display = "none";
									nextButton.style.display = "none";
								} else {
									prevButton.style.display = "";
									nextButton.style.display = "";
								}
							}
						};
			
						// Run after mount and on resize
						toggleArrows();
						videoCarousel.on("resize", toggleArrows);
		}
	}
});

//loop through the videos
const videos = document.querySelectorAll(".video");

if (videos.length > 0) {
	const videoModalOuter = document.querySelector(".video-modal-outer");
	const videoModalInner = document.querySelector(".video-modal-inner");
	const videoModal = document.querySelector(".video-modal");
	const closeButton = document.querySelector(".video-close-modal");

	function handleButtonClick(e) {
		const videoCard = e.currentTarget;
		const videoType = videoCard.dataset.videoType;
		const videoId = videoCard.dataset.videoId;

		if (videoType && videoId) {
			// Build the iframe HTML based on video type
			let iframeHtml = "";
			if (videoType === "youtube") {
				iframeHtml =
					'<div class="responsive-iframe-container">' +
					'<iframe width="375px" height="auto" src="https://www.youtube.com/embed/' +
					videoId +
					'" frameborder="0" allowfullscreen></iframe>' +
					"</div>";
			} else if (videoType === "vimeo") {
				iframeHtml =
					'<div class="responsive-iframe-container">' +
					'<iframe src="https://player.vimeo.com/video/' +
					videoId +
					'" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' +
					"</div>";
			} else if (videoType === "wistia") {
				iframeHtml =
					'<div class="responsive-iframe-container">' +
					'<iframe src="https://fast.wistia.net/embed/iframe/' +
					videoId +
					'?seo=true&videoFoam=false" frameborder="0" allowfullscreen></iframe>' +
					'<script src="https://fast.wistia.net/assets/external/E-v1.js" async></script>' +
					"</div>";
			}

			// Update modal content and display modal
			videoModal.innerHTML = iframeHtml;
			videoModalOuter.classList.add("open");
		} else {
			console.warn("Video data not found on card.");
		}
	}

	videos.forEach((video) => {
		video.addEventListener("click", handleButtonClick);
	});

	function closeModal() {
		videoModalOuter.classList.remove("open");
	}

	if (videoModalOuter) {
		videoModalOuter.addEventListener("click", (e) => {
			const isOutside = !e.target.closest(".video-modal-inner");
			if (isOutside) {
				closeModal();
			}
		});
	}

	if (closeButton) {
		closeButton.addEventListener("click", () => {
			closeModal();
		});
	}
}
